<template>
  <base-card title="Saldo">
    <div class="space-y-4">
      <div
        v-for="(balance, index) in balanceUsed"
        :key="index"
        class="grid grid-cols-2 items-center"
      >
        <base-checkbox
          :name="balance.id"
          :label="`${balance.name} (${toCurrency(balance.balance)})`"
          :disabled="disabled || !balance.balance"
          v-model="balanceUsed[index].used"
          @uncheck="onUncheckBalance(index)"
        />
        <base-input
          :disabled="disabled || !balance.used"
          type="text"
          inset
          with-label
          currency
          label="Nominal"
          placeholder="100000"
          debounce
          v-model="balanceUsed[index].amount"
          @native-input="onChangeAmount(index)"
        >
          <template v-if="balance.paymentMethodId && balance.saved" #next-input>
            <Icon icon="heroicons:check-circle-solid" class="text-green-500 absolute right-3 w-5 h-5" style="top: 24px" />
          </template>
        </base-input>
      </div>
    </div>
    <loading v-if="loading" />
  </base-card>
</template>

<script>
import { requestMixin } from '@/mixins/request/request';
import BaseCheckbox from '@/components/base/BaseCheckbox.vue';
import { toCurrency } from '@/services/currency.service';
import { mapActions } from 'vuex';

export default {
  components: { BaseCheckbox },
  mixins: [requestMixin],
  props: {
    value: Array,
    paymentId: String,
    disabled: Boolean,
  },
  emits: ['input', 'deleted', 'update-restock-balance'],
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    balanceUsed: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  methods: {
    ...mapActions({
      createAlert: 'alert/createAlert',
    }),
    toCurrency,
    async createPaymentMethod(balance) {
      this.loading = true;

      const [res, err] = await this.request('/api/v1/payment-methods', {
        method: 'post',
        data: {
          data: {
            type: 'payment-methods',
            attributes: {
              balance_used: balance.id,
              payment_amount: +balance.amount.replace(/\D/gi, ''),
            },
            relationships: {
              payment: {
                data: {
                  type: 'payments',
                  id: this.paymentId,
                },
              },
            },
          },
        },
      });

      if (err) {
        this.createAlert({
          data: this.getRequestErrorMessage(err),
          status: 'error',
        });
      }

      this.loading = false;

      return [res, err];
    },
    async updatePaymentMethod(balance) {
      this.loading = true;

      const [res, err] = await this.request(
        `/api/v1/payment-methods/${balance.paymentMethodId}`,
        {
          method: 'patch',
          data: {
            data: {
              type: 'payment-methods',
              id: balance.paymentMethodId,
              attributes: {
                payment_amount: +balance.amount.replace(/\D/gi, ''),
              },
            },
          },
        }
      );

      if (err) {
        this.createAlert({
          data: this.getRequestErrorMessage(err),
          status: 'error',
        });
      }

      this.loading = false;

      return [res, err];
    },
    async deletePaymentMethod(balance) {
      this.loading = true;

      const [res, err] = await this.request(
        `/api/v1/payment-methods/${balance.paymentMethodId}`,
        {
          method: 'delete'
        }
      );

      if (err) {
        this.createAlert({
          data: this.getRequestErrorMessage(err),
          status: 'error',
        });
      }

      this.loading = false;

      return [res, err];
    },
    async onUncheckBalance(index) {
      const balance = this.balanceUsed[index];

      if (balance.paymentMethodId) {
        const [, err] = await this.deletePaymentMethod(balance)

        if (err) {
          this.balanceUsed[index].amount = !balance.used;
        } else {
          if (balance.type === 'restock_balance') {
            this.balanceUsed[index].balance += +balance.amount.replace(/\D/gi, '')
          }

          this.balanceUsed[index].paymentMethodId = null;
          this.balanceUsed[index].amount = null;
          this.balanceUsed[index].originalAmount = null;
        }
      } else {
        this.balanceUsed[index].amount = null;
        this.balanceUsed[index].originalAmount = null;
      }
    },
    async onChangeAmount(index) {
      const balance = this.balanceUsed[index];

      this.balanceUsed[index].saved = false

      const [res, err] = balance.paymentMethodId
        ? await this.updatePaymentMethod(balance)
        : await this.createPaymentMethod(balance);

      if (err) {
        this.balanceUsed[index].amount = balance.originalAmount;
      } else {
        this.balanceUsed[index].paymentMethodId = res.data.id;

        if (balance.type === 'restock_balance') {
          this.balanceUsed[index].balance = res.data.attributes.temp_restock_balance;

          this.$emit('update-restock-balance', res.data.attributes.temp_restock_balance)
        }

        this.balanceUsed[index].originalAmount = this.balanceUsed[index].amount;
      }

      this.balanceUsed[index].saved = true
    },
  },
};
</script>
